var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _rect5, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurAppBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 515,
    viewBox: "0 0 1440 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2924_4191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1312,
    y: 0,
    width: 128,
    height: 187
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1312,
    width: 128,
    height: 187,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2924_4191)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1312,
    y: 64.5789,
    width: 58.9474,
    height: 58.9474,
    rx: 2,
    fill: "url(#paint0_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1393.05,
    y: 13,
    width: 73.6842,
    height: 73.6842,
    rx: 2,
    fill: "url(#paint1_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1407.79,
    y: 108.789,
    width: 44.2105,
    height: 44.2105,
    rx: 2,
    fill: "url(#paint2_linear_2924_4191)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2924_4191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 328,
    width: 128,
    height: 187
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 515,
    width: 128,
    height: 187,
    transform: "rotate(180 128 515)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2924_4191)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 450.421,
    width: 58.9474,
    height: 58.9474,
    rx: 2,
    transform: "rotate(180 128 450.421)",
    fill: "url(#paint3_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.9474,
    y: 502,
    width: 73.6842,
    height: 73.6842,
    rx: 2,
    transform: "rotate(180 46.9474 502)",
    fill: "url(#paint4_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2105,
    y: 406.211,
    width: 44.2105,
    height: 44.2105,
    rx: 2,
    transform: "rotate(180 32.2105 406.211)",
    fill: "url(#paint5_linear_2924_4191)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2924_4191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 227,
    y: 85,
    width: 47,
    height: 55
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 273.644,
    y: 140,
    width: 46.2871,
    height: 55,
    transform: "rotate(180 273.644 140)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2924_4191)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.716,
    y: 121.006,
    width: 17.3375,
    height: 17.3375,
    rx: 2,
    transform: "rotate(180 273.716 121.006)",
    fill: "url(#paint6_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.877,
    y: 136.176,
    width: 21.6718,
    height: 21.6718,
    rx: 2,
    transform: "rotate(180 249.877 136.176)",
    fill: "url(#paint7_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.543,
    y: 108.003,
    width: 13.0031,
    height: 13.0031,
    rx: 2,
    transform: "rotate(180 245.543 108.003)",
    fill: "url(#paint8_linear_2924_4191)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2924_4191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1043,
    y: 270,
    width: 47,
    height: 55
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1089.29,
    y: 325,
    width: 46.2871,
    height: 55,
    transform: "rotate(180 1089.29 325)",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2924_4191)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1089.36,
    y: 306.006,
    width: 17.3375,
    height: 17.3375,
    rx: 2,
    transform: "rotate(180 1089.36 306.006)",
    fill: "url(#paint9_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.52,
    y: 321.176,
    width: 21.6718,
    height: 21.6718,
    rx: 2,
    transform: "rotate(180 1065.52 321.176)",
    fill: "url(#paint10_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1061.19,
    y: 293.003,
    width: 13.0031,
    height: 13.0031,
    rx: 2,
    transform: "rotate(180 1061.19 293.003)",
    fill: "url(#paint11_linear_2924_4191)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2924_4191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 540,
    y: 174,
    width: 47,
    height: 55
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 586.287,
    y: 229,
    width: 46.2871,
    height: 55,
    transform: "rotate(180 586.287 229)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2924_4191)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.36,
    y: 210.006,
    width: 17.3375,
    height: 17.3375,
    rx: 2,
    transform: "rotate(180 586.36 210.006)",
    fill: "url(#paint12_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.521,
    y: 225.176,
    width: 21.6718,
    height: 21.6718,
    rx: 2,
    transform: "rotate(180 562.521 225.176)",
    fill: "url(#paint13_linear_2924_4191)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.187,
    y: 197.003,
    width: 13.0031,
    height: 13.0031,
    rx: 2,
    transform: "rotate(180 558.187 197.003)",
    fill: "url(#paint14_linear_2924_4191)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2924_4191",
    x1: 1313.57,
    y1: 74.7608,
    x2: 1370.03,
    y2: 76.0322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2924_4191",
    x1: 1395.01,
    y1: 25.7273,
    x2: 1465.59,
    y2: 27.3166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2924_4191",
    x1: 1408.96,
    y1: 116.426,
    x2: 1451.31,
    y2: 117.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2924_4191",
    x1: 129.566,
    y1: 460.603,
    x2: 186.03,
    y2: 461.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2924_4191",
    x1: 48.9046,
    y1: 514.727,
    x2: 119.485,
    y2: 516.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2924_4191",
    x1: 33.3849,
    y1: 413.847,
    x2: 75.7329,
    y2: 414.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2924_4191",
    x1: 274.177,
    y1: 124.001,
    x2: 290.784,
    y2: 124.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2924_4191",
    x1: 250.453,
    y1: 139.92,
    x2: 271.212,
    y2: 140.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2924_4191",
    x1: 245.888,
    y1: 110.249,
    x2: 258.344,
    y2: 110.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2924_4191",
    x1: 1089.82,
    y1: 309.001,
    x2: 1106.43,
    y2: 309.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2924_4191",
    x1: 1066.1,
    y1: 324.92,
    x2: 1086.86,
    y2: 325.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2924_4191",
    x1: 1061.53,
    y1: 295.249,
    x2: 1073.99,
    y2: 295.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00316B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2924_4191",
    x1: 586.631,
    y1: 213.316,
    x2: 603.493,
    y2: 213.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2924_4191",
    x1: 562.859,
    y1: 229.314,
    x2: 583.938,
    y2: 229.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2924_4191",
    x1: 558.39,
    y1: 199.485,
    x2: 571.037,
    y2: 199.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurAppBg);
export default __webpack_public_path__ + "static/media/our_app_bg.ed1f80c1d1f058ca9a5fcf3bd9c1ebac.svg";
export { ForwardRef as ReactComponent };